<template>
	<v-card outlined class="pa-2 mt-3" elevation="3">
		<!-- activity -->
		<!-- activity -->
		<div v-if="userProfile.role !== 'person'" class="mb-4">
			<v-card outlined class="pa-2">
				<edit-lodging :close="close" :sendAllNotes="sendAllNotes" />
			</v-card>
		</div>

		<v-divider class="my-4" />

		<!-- Documents and Notes side by side -->
		<v-row v-if="editMode || userProfile.role == 'person'">
			<v-col cols="12" md="6">
				<v-card outlined class="pa-2 fill-height">
					<div class="subtitle-1 font-weight-bold ml-2 mb-2">Documentos</div>
					<resumen-o-t
						:selectedPlace="selectedPlace"
						:person="persons.find(p => p._id === lodgingSelect.person)"
						:lodgingSelect="lodgingSelect"
					/>
					<v-card flat>
						<v-card-text>
							<v-row>
								<v-col>
									<v-btn @click="dialog = true" small color="success">
										Agregar archivo
										<v-icon right>mdi-plus</v-icon>
									</v-btn>
								</v-col>
								<template v-if="userProfile.role == 'person'">
									<v-col>
										<v-btn
											small
											color="primary"
											:to="
												`/nueva-orden-de-trabajo/lusazu/?idLodging=${lodgingSelect._id}`
											"
										>
											Sanitizacion/desinsectacion
											<v-icon right>mdi-plus</v-icon>
										</v-btn>
									</v-col>
								</template>
								<template v-if="userProfile.role == 'person'">
									<v-col>
										<v-btn
											small
											color="primary"
											:to="
												`/nueva-orden-de-trabajo/roedores/?idLodging=${lodgingSelect._id}`
											"
										>
											Roedores
											<v-icon right>mdi-plus</v-icon>
										</v-btn>
									</v-col>
								</template>
							</v-row>
						</v-card-text>
						<v-card-text>
							Se recomiendo no ingresar mas de 2 ordenes de trabajo por actividad
							<br />

							<v-btn
								small
								v-for="(order, i) in orderlusazu"
								:key="'lusazu' + i"
								:href="generateWorkOrderLink(order)"
								target="_blank"
								class="ma-2"
							>
								Sanitizacion/desinsectacion {{ i + 1 }}
							</v-btn>
							<v-btn
								small
								v-for="(order, i) in preRoedoreslusazu"
								:key="'pre-roedores' + i"
								:href="finisheWorkOrderLink(order)"
								target="_blank"
								class="ma-2"
								color="info"
							>
								Pre Roedores {{ i + 1 }}
							</v-btn>
							<v-btn
								small
								v-for="(order, i) in roedoreslusazu"
								:key="'roedores' + i"
								:href="generateWorkOrderLink(order)"
								target="_blank"
								class="ma-2"
							>
								Roedores {{ i + 1 }}
							</v-btn>
							<v-btn
								small
								v-for="(order, i) in orderMicroorganismos"
								:key="'microorganismos' + i"
								:href="generateWorkOrderLink(order)"
								target="_blank"
								class="ma-2"
							>
								Microorganismos {{ i + 1 }}
							</v-btn>
						</v-card-text>
						<v-card-text>
							<v-slide-group
								center-active
								show-arrows
								v-if="lodgingSelect"
								v-model="item"
							>
								<v-slide-item
									v-for="(document, i) in lodgingSelect.documents"
									:key="i"
									v-slot="{ toggle }"
									:value="document.length"
								>
									<v-card
										outlined
										class="ma-4 bgCard"
										height="130"
										width="200"
										color="transparent"
										@click="toggle"
									>
										<v-card-text style="height: 40px;" class="pt-2 pb-0">
											{{
												document.filename
													? cutText(document.filename)
													: 'Sin nombre'
											}}
										</v-card-text>
										<v-divider />
										<v-card-text class="pb-0 pt-2" style="height: 50px">
											<div
												v-if="document.user.name"
												class="caption text--secondary"
											>
												Subido por: {{ cutText(document.user.name) }}
											</div>
											<div class="success--text" style="font-size: 10px">
												Creado el {{ createAt(document.createAt) }}
											</div>
										</v-card-text>
										<v-card-actions style="height: 40px">
											<v-spacer></v-spacer>
											<v-btn
												:href="document.url"
												target="_blank"
												x-small
												color="success"
											>
												Descargar
												<v-icon small right>mdi-download</v-icon>
											</v-btn>
											<v-spacer></v-spacer>
										</v-card-actions>
									</v-card>
								</v-slide-item>
								{{ toggle }}
							</v-slide-group>
						</v-card-text>
					</v-card>
				</v-card>
			</v-col>
			<v-col cols="12" md="6">
				<v-card outlined class="pa-2 fill-height">
					<div class="subtitle-1 font-weight-bold ml-2 mb-2">Notas</div>
					<v-card flat>
						<v-card-text class="text-left">
							<div
								style=" overflow: auto;"
								v-if="lodgingSelect && lodgingSelect.notes.length"
								class="note"
							>
								<div v-for="note in notes" :key="note._id">
									<div class="text-capitalize">
										{{ note.sender }} -
										<small>{{ formatDate(note.createdAt) }}</small>
									</div>
									<p class="caption" max-width="200">
										{{ note.text }}
									</p>
								</div>
							</div>
							<v-alert v-else class="tilte text-center">No tienes notas</v-alert>
							<v-textarea
								v-model="note"
								outlined
								filled
								hide-details
								label="Escribir nota"
								counter="1000"
								rows="2"
								:rules="[rules.length(1001)]"
								class="my-1"
								append-icon="mdi-comment"
							></v-textarea>
							<div class="text-center">
								<v-btn
									type="submit"
									color="success"
									small
									@click="submitNotes"
									:loading="loadingSetNotes"
									>Agregar</v-btn
								>
							</div>
						</v-card-text>
					</v-card>
				</v-card>
			</v-col>
		</v-row>

		<!-- Notes TimelineAll (when !editMode) -->
		<div v-else-if="!editMode">
			<div class="subtitle-1 font-weight-bold ml-2 mb-2">Notas</div>
			<v-card flat>
				<v-card-text class="text-left">
					<div style="height: 100px; overflow: auto;" class="note">
						<div v-for="note in allNotes" :key="note._id">
							<div class="text-capitalize">
								{{ note.sender }} -
								<small>{{ formatDate(note.createdAt) }}</small>
							</div>
							<p class="caption" max-width="200">
								{{ note.text }}
							</p>
						</div>
					</div>
					<v-textarea
						v-model="note"
						label="Escribir nota"
						counter="1000"
						outlined
						rows="2"
						:rules="[rules.length(1001)]"
						class="mt-1"
						append-icon="mdi-comment"
					></v-textarea>
					<div class="text-right">
						<v-btn
							type="submit"
							color="success"
							small
							@click="addNote"
							:loading="loadingSetNotes"
							>Agregar</v-btn
						>
					</div>
				</v-card-text>
			</v-card>
		</div>

		<footer-lodging v-if="userProfile.role !== 'person'" :close="close" />
		<!-- dialog stepper -->
		<v-dialog v-if="lodgingSelect" v-model="dialog" max-width="550" style="position: relative">
			<upload-documents
				:close="() => (dialog = false)"
				:viewFinal="() => viewFinal()"
				:id="lodgingSelect._id"
			/>
		</v-dialog>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
	components: {
		EditLodging: () => import('@/components/lodgings/EditLodging'),
		FooterLodging: () => import('@/components/lodgings/FooterLodging'),
		UploadDocuments: () => import('@/components/persons/UploadDocuments'),
		resumenOT: () => import('@/components/lodgings/resumenOT'),
	},
	props: {
		close: {
			type: Function,
			default: () => null,
		},
	},
	data() {
		return {
			formBiotecPlagas: false,
			formAgroServices: false,
			formCicloUrbano: false,
			formCicloUrbanoPiscinas: false,
			formUrbanPlagas: false,
			orderDialog: false,
			order: null,
			loadingSetNotes: false,

			dialog: false,
			toggle: null,
			item: null,
			note: '',
			rules: {
				length: len => v => (v || '').length < len || `Maximo ${len - 1} caracteres`,
			},
			adminRole: '',
			allNotes: [],
		};
	},
	computed: {
		orderMicroorganismos() {
			return this.lodgingSelect.workOrder.filter(order => order.type == 'microorganismos');
		},
		orderlusazu() {
			return this.lodgingSelect.workOrder.filter(order => order.type == 'lusazu');
		},
		preRoedoreslusazu() {
			return this.lodgingSelect.workOrder.filter(order => order.type == 'pre-roedores');
		},
		roedoreslusazu() {
			return this.lodgingSelect.workOrder.filter(order => order.type == 'roedores');
		},
		notes() {
			let notes = this.lodgingSelect.notes;
			return notes.reverse();
		},
		person() {
			if (this.persons.length)
				return this.persons.find(
					person =>
						person._id == this.lodgingSelect.person._id ||
						person._id == this.lodgingSelect.person
				);
			return null;
		},
		statePhonePerson() {
			if (this.person) return this.person.isPhoneVerified;
			else return 0;
		},
		hasPhone() {
			if (this.person) {
				if (this.person.phone) return true;
				else return false;
			} else return false;
		},
		isUser() {
			if (this.person) {
				return this.person.isUser;
			} else return false;
		},
		isToday() {
			if (this.lodgingSelect) {
				if (this.lodgingSelect.start && this.lodgingSelect.end)
					return moment().isBetween(
						moment(this.lodgingSelect.start),
						moment(this.lodgingSelect.end),
						'day',
						'[]'
					);
			}
			return false;
		},
		lastConfirmationSms() {
			const lastNotificationsIndex = this.lodgingSelect.userNotifications.length - 1;
			if (lastNotificationsIndex > 0)
				return moment(
					this.lodgingSelect.userNotifications[lastNotificationsIndex].date
				).fromNow();
			return '';
		},
		...mapGetters({
			persons: 'Person/persons',
			lodgingSelect: 'Lodging/lodgingSelect',
			selectedPlace: 'Lodging/selectedPlace',
			editMode: 'Lodging/editMode',
			getPerson: 'Person/person',
		}),
	},
	mounted() {
		this.scrollToElement();
		if (this.userProfile.role === 'person') {
			this.getAdminRole(this.getPerson.idCompany);
		}
	},
	methods: {
		async submitNotes() {
			this.loadingSetNotes = true;
			if (this.note.length < 1001)
				await this.updateNotes({
					currentRoute: this.$route.name,
					lodgingId: this.lodgingSelect._id,
					note: {
						sender: `${this.userProfile.name} ${this.userProfile.lastName}`,
						text: this.note,
					},
				});
			this.note = '';
			this.scrollToElement();
			this.loadingSetNotes = false;
		},
		async sendAllNotes(newLodgings) {
			this.loadingSetNotes = true;
			if (this.note.length < 1001) {
				await this.updateAllNotes({
					lodgings: newLodgings,
					notes: this.allNotes,
				});
			}
			this.loadingSetNotes = false;
		},
		async getAdminRole(id) {
			this.adminRole = await this.fetchAdminProfile(id);
		},
		addNote() {
			this.allNotes.push({
				sender: `${this.userProfile.name} ${this.userProfile.lastName}`,
				text: this.note,
			});
			this.note = '';
			this.scrollToElement();
		},
		cutText(text) {
			if (text.length > 15) {
				return `${text.split('.')[0].substr(0, 18)}...`;
			}
			return text;
		},
		createAt(date) {
			return moment(date).format('lll');
		},
		viewFinal() {
			if (this.lodgingSelect && this.lodgingSelect.documents.length)
				this.item = this.lodgingSelect.documents.length - 1;
		},
		scrollToElement() {
			const el = this.$el.getElementsByClassName('note')[0];
			if (el) {
				el.scrollTop = 0;
			}
		},
		formatDate(date) {
			return moment(date).format('DD-MM-YYYY HH:mm');
		},
		generateWorkOrderLink(workOrder) {
			return `#/${workOrder.type}/${this.lodgingSelect._id}/work-order/${workOrder.index}`;
		},
		finisheWorkOrderLink(workOrder) {
			return `#/nueva-orden-de-trabajo/${workOrder.type}/${this.lodgingSelect._id}/${workOrder.index}`;
		},
		...mapActions({
			updateNotes: 'Lodging/updateNotes',
			fetchAdminProfile: 'User/fetchAdminProfile',
			updateAllNotes: 'Lodging/updateAllNotes',
		}),
	},
};
</script>
